import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};

function* getTaxList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    // Existing behavior: fetch only the requested page
    if (!actions.getAllItem) {
      let url =
        actions.query === null
          ? apiUrl + "/opa-taxes?page=" + actions.page
          : apiUrl + "/opa-taxes" + actions.query;

      if (enviromentUrl !== "") {
        if (url.includes("?")) {
          url += `&env=${enviromentUrl}`;
        } else {
          url += `?env=${enviromentUrl}`;
        }
      }

      const response = yield call(apiCall, "get", url, requestOptions);

      yield put({
        type: "LIST_TAX_RESPONSE_GET",
        value: response,
      });

      return;
    }

    // Fetch all pages
    let page = 1;
    const pageSize = 1000;
    let allTaxRecords = [];
    let response;

    while (true) {
      let url = `${apiUrl}/opa-taxes?page_size=${pageSize}&page=${page}`;

      if (enviromentUrl !== "") {
        if (url.includes("?")) {
          url += `&env=${enviromentUrl}`;
        } else {
          url += `?env=${enviromentUrl}`;
        }
      }

      response = yield call(apiCall, "get", url, requestOptions);

      const records = response?.records || [];
      allTaxRecords = [...allTaxRecords, ...records];

      // Stop when fewer than pageSize records are returned
      if (records.length < pageSize) {
        break;
      }

      page++;
    }

    yield put({
      type: "LIST_TAX_RESPONSE_GET",
      value: {
        ...response,
        records: allTaxRecords,
      },
    });
  } catch (error) {
    yield put({
      type: "LIST_TAX_RESPONSE_GET",
      value: error,
    });
  }
}

function* getTax(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-tax/${actions.query}?include=products`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "TAX_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "TAX_RESPONSE_GET", value: error });
  }
}

function* resetTax() {
  yield put({ type: "TAX_RESPONSE_RESET" });
}

function* addTax(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-tax";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "TAX_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "TAX_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* editTax(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };

    let url = `${apiUrl}/opa-tax/${actions.taxUuid}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      // if (response.updatedAt || response.uuid) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }
    yield put({
      type: "TAX_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "TAX_RESPONSE_EDIT",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteTax(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-tax/${actions.taxUuid}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "TAX_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "TAX_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* addTaxProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.taxFormData),
    };

    let url = apiUrl + "/opa-tax/" + actions.form.taxUuid + "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (Array.isArray(response) || response.success) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "TAX_PRODUCT_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "TAX_PRODUCT_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* deleteTaxProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.payload.taxFormData),
    };

    let url = apiUrl + "/opa-tax/" + actions.payload.taxUuid + "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "TAX_PRODUCT_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "TAX_PRODUCT_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getProductTax(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url;
    if (actions.taxUuid) {
      url = `${apiUrl}/opa-product-tax/${actions.productUuid}/${actions.taxUuid}`;
    } else {
      url = `${apiUrl}/opa-product-tax/${actions.productUuid}`;
    }

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "PRODUCT_TAX_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "PRODUCT_TAX_RESPONSE_GET", value: error });
  }
}

function* getTaxProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-tax/${actions.taxUuid}`;
    if (enviromentUrl !== "") {
      url += `?env=${enviromentUrl}`;
    }

    const taxResponse = yield call(apiCall, "get", url, requestOptions);

    if (
      taxResponse &&
      taxResponse.products &&
      Array.isArray(taxResponse.products) &&
      taxResponse.products.length > 0
    ) {
      yield put({
        type: "TAX_PRODUCTS_RESPONSE_GET",
        value: taxResponse.products,
      });
    } else {
      yield put({ type: "TAX_PRODUCTS_RESPONSE_GET", value: [] });
    }
  } catch (error) {
    yield put({ type: "TAX_PRODUCTS_RESPONSE_GET", value: [] });
  }
}

function* updateTax(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-tax/" + actions.taxUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "TAX_RESPONSE_UPDATE",
      value: { ...response, responseStatus },
    });
  } catch (error) {
    yield put({
      type: "TAX_RESPONSE_UPDATE",
      value: { ...error, responseStatus: "error" },
    });
  }
}

function* getProductTaxList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-product-tax/${actions.productUuid}`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_PRODUCT_TAX_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_PRODUCT_TAX_RESPONSE_GET", value: error });
  }
}
function* addTaxesProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.taxUuids),
    };

    let url = apiUrl + "/opa-product-taxes/" + actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (Array.isArray(response) || response.success) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "TAXES_PRODUCT_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "TAXES_PRODUCT_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* deleteTaxesProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.taxUuids),
    };

    let url = apiUrl + "/opa-product-taxes/" + actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }
    yield put({
      type: "TAXES_PRODUCT_RESPONSE_DELETE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "TAXES_PRODUCT_RESPONSE_DELETE",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

export function* getSagaTaxList() {
  yield takeEvery("GET_LIST_TAX", getTaxList);
}

export function* getSagaProductTaxList() {
  yield takeEvery("GET_LIST_PRODUCT_TAX", getProductTaxList);
}

export function* getSagaTax() {
  yield takeEvery("GET_TAX", getTax);
}

export function* resetSagaTax() {
  yield takeEvery("RESET_TAX", resetTax);
}

export function* addSagaTax() {
  yield takeEvery("ADD_TAX", addTax);
}

export function* editSagaTax() {
  yield takeEvery("EDIT_TAX", editTax);
}

export function* deleteSagaTax() {
  yield takeEvery("DELETE_TAX", deleteTax);
}

export function* addSagaTaxProduct() {
  yield takeEvery("ADD_TAX_PRODUCT", addTaxProduct);
}

export function* deleteSagaTaxProduct() {
  yield takeEvery("DELETE_TAX_PRODUCTS", deleteTaxProducts);
}

export function* getSagaProductTax() {
  yield takeEvery("GET_PRODUCT_TAX", getProductTax);
}

export function* getSagaTaxProducts() {
  yield takeEvery("GET_TAX_PRODUCTS", getTaxProducts);
}

export function* updateSagaTax() {
  yield takeEvery("UPDATE_TAX", updateTax);
}

export function* addSagaTaxesProduct() {
  yield takeEvery("ADD_TAXES_PRODUCT", addTaxesProduct);
}

export function* deleteSagaTaxesProduct() {
  yield takeEvery("DELETE_TAXES_PRODUCT", deleteTaxesProduct);
}
